import useCreateMeeting from "./CreateMeeting.utils";
import FileRow from "./FileRow";
import { Icons } from "../../constants/icon-library";
import { useDispatch, useSelector } from "react-redux";
import { getParticipants } from "../../features/participant/participantSlice";
import { useEffect, useState } from "react";
import AddParticipantModal from "./AddParticipantModal";
import ParticipantsSection from "./ParticipantsSection";
import { fetchSettingDetailsByUserId } from "../../features/settings/settingsSlice";

const CreateMeeting = () => {
  const {
    formik,
    agents,
    uploadedFiles,
    doneFiles,
    doneCounts,
    anyUploading,
    loading,
    handleRemove,
    getRootProps,
    getInputProps,
    isDragActive,
    navigate,
  } = useCreateMeeting();

  const dispatch = useDispatch();

  const { participants = [] } = useSelector((state) => state.participants);
  const [showAgent, setShowAgent] = useState(false);
  const [showAddParticipant, setShowAddParticipant] = useState(false);
  const { userSettings } = useSelector((state) => state.setting);

  useEffect(() => {
    dispatch(getParticipants());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchSettingDetailsByUserId());
  }, [dispatch]);

  const handleParticipantAdded = (newParticipant) => {
    if (newParticipant?.uuid) {
      const current = formik.values.participants || [];

      formik.setFieldValue("participants", [...current, newParticipant.uuid]);
    }
  };

  return (
    <div className="content">
      <div className="row pt-3">
        <div className="card border p-0">
          <div className="card-header p-4 border-bottom bg-body d-flex align-items-center">
            <i className={`wb ${Icons("add")} fs-8 me-2`} />
            <h3 className="mb-0">New Meeting</h3>
          </div>

          <div className="card-body">
            <form onSubmit={formik.handleSubmit}>
              <div className="row align-items-stretch">
                <div className="col-md-6 d-flex">
                  <div
                    className="mb-4 d-flex flex-column w-100"
                    style={{ height: "50vh" }}
                  >
                    <div className="d-flex justify-content-between">
                      <div>
                        {" "}
                        <label className="fw-bold mb-2">Upload File</label>
                      </div>{" "}
                      <div>
                        {" "}
                        {doneFiles.length > 0 && (
                          <p className="text-muted small mb-0 mt-1">
                            {doneCounts.recordings > 0 &&
                              `${doneCounts.recordings} audio · `}
                            {doneCounts.documents > 0 &&
                              `${doneCounts.documents} document${doneCounts.documents !== 1 ? "s" : ""} · `}
                            {doneFiles.length} file
                            {doneFiles.length !== 1 ? "s" : ""} ready
                            {anyUploading ? " · uploading…" : ""}
                          </p>
                        )}
                      </div>
                    </div>

                    <div
                      {...getRootProps()}
                      className={`border rounded p-3 mb-1 text-center ${
                        isDragActive
                          ? "border-primary bg-primary bg-opacity-10"
                          : "border-dashed"
                      }`}
                      style={{
                        cursor: "pointer",
                        transition: "all 0.2s",
                        flexShrink: uploadedFiles.length > 0 ? 0 : undefined,
                        flex: uploadedFiles.length > 0 ? undefined : 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-2" style={{ fontSize: 32 }}>
                        {isDragActive ? "📂" : "⬆️"}
                      </div>
                      <p className="mb-1 fw-semibold">
                        {isDragActive
                          ? "Release to upload"
                          : "Drop files here, or click to browse"}
                      </p>
                      <p className="text-muted small mb-3">
                        MP3, M4A, WAV · PDF, DOC, DOCX · Images
                      </p>
                      <button type="button" className="btn btn-primary btn-sm">
                        <i className={`wb ${Icons("add")} me-1`} />
                        Browse Files
                      </button>
                    </div>

                    {uploadedFiles.length > 0 && (
                      <div
                        className="border rounded p-2 mb-1"
                        style={{ flex: 1, minHeight: 0, overflowY: "auto" }}
                      >
                        {uploadedFiles.map((item) => (
                          <FileRow
                            key={item.id}
                            item={item}
                            onRemove={handleRemove}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6 d-flex">
                  <div
                    className="mb-4 d-flex flex-column w-100"
                    style={{ height: "50vh" }}
                  >
                    <label className="fw-bold mb-2">Meeting Transcript</label>
                    <textarea
                      name="rawText"
                      className={`form-control flex-fill ${
                        formik.touched.rawText && formik.errors.rawText
                          ? "is-invalid"
                          : ""
                      }`}
                      value={formik.values.rawText}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Type or paste your meeting transcript here…"
                      style={{ resize: "none" }}
                    />

                    {formik.touched.rawText && formik.errors.rawText && (
                      <div className="invalid-feedback d-block">
                        {formik.errors.rawText}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {formik.submitCount > 0 &&
                doneFiles.length === 0 &&
                !formik.values.rawText.trim() && (
                  <div className="alert alert-warning py-2 mb-3 d-flex align-items-center  text-black gap-2">
                    <i className={`wb ${Icons("warning")}`} />
                    <span>
                      Please upload at least one file or transcription text.
                    </span>
                  </div>
                )}
              {/* Add Participant */}
              <ParticipantsSection
                participants={participants}
                selectedParticipants={formik.values.participants || []}
                onParticipantsChange={(selected) =>
                  formik.setFieldValue("participants", selected)
                }
                setShowAddParticipant={setShowAddParticipant}
              />

              <div className="d-flex justify-content-end align-items-center mt-4">
                <button
                  type="button"
                  onClick={() => setShowAgent((prev) => !prev)}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  className="bg-transparent border-0 p-0 text-primary d-flex align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <i
                    className={`wb ${showAgent ? Icons("arrowDown") : Icons("arrowUp")}`}
                  />
                  <span className="text-primary">Advance</span>
                </button>
              </div>

              {showAgent ? (
                <div className="mb-4">
                  <label className="fw-bold mb-2">
                    Agent Name <span className="text-danger">*</span>
                  </label>

                  <select
                    className="form-select"
                    name="agent"
                    value={formik.values.agent}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {agents.map((agent) => (
                      <option key={agent.uuid} value={agent.uuid}>
                        {agent.name}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                ""
              )}

              <div className="mb-3">
                <label className="fw-bold mb-2">
                  Meeting Name <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  name="name"
                  className={`form-control ${
                    formik.touched.name && formik.errors.name
                      ? "is-invalid"
                      : ""
                  }`}
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter meeting name"
                />

                {formik.touched.name && formik.errors.name && (
                  <div className="invalid-feedback">{formik.errors.name}</div>
                )}
              </div>
              {/* Buttons */}
              <div className="d-flex justify-content-between align-items-center mt-4">
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => navigate("/meetings")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary btn-sm d-flex align-items-center gap-2"
                  disabled={loading || anyUploading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" />
                      Submitting…
                    </>
                  ) : anyUploading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" />
                      Uploading files…
                    </>
                  ) : (
                    <>
                      <i className={`wb ${Icons("light")} `} />
                      Generate Tasks
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* ── Add Participant Modal ── */}
      <AddParticipantModal
        show={showAddParticipant}
        onHide={() => setShowAddParticipant(false)}
        onParticipantAdded={handleParticipantAdded}
        settings={userSettings}
      />
    </div>
  );
};

export default CreateMeeting;
